export const inIframe = () => window.self !== window.top;
